import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import MotivationCardsView from "./MotivationCardsView";

const DashboardSuggestion = ({}) => {
  const { t } = useTranslation();

  const [tab, setTab] = useState("Daily Motivation");
  const [selectedDay, setSelectedDay] = useState("Monday");
  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  return (
    <div
      className="bg-white shadow-lg p-3 md:p-6 rounded-lg w-full max-w-full bg-cover h-[100%] mt-12"
    //   style={{ backgroundImage: `url(${BackImg})` }}
    >
      <div className="flex flex-col gap-2 md:flex-row justify-between items-center mb-4">
        <h2 className="font-[600] text-[#000] text-[16px] font-[Lato]">
         Motivation Overview
        </h2>

        <div className="gird grid-cols-2 bg-white rounded-full shadow-md md:p-0 border border-[#E9E9E9]">
          {["Daily Motivation", "Weekly Motivation"].map((item) => {
            const isActive = tab === item;
            return (
              <button
                key={item}
                onClick={() => setTab(item)}
                className={`relative flex-1 px-6 py-3 rounded-full capitalize transition-all duration-300 min-w-[120px] text-center ${
                  isActive
                    ? "text-white bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] "
                    : "bg-white text-black"
                }`}
              >
                <span className="flex items-center justify-center gap-2 relative text-[12px] font-[600]">
                  {/* {item} */}

                  {item}
                </span>
              </button>
            );
          })}
        </div>
      </div>

      {tab === "Weekly Motivation" ? (
        <div className="border rounded-[17px] p-4 bg-white font-[Lato]">
          <div className="flex items-center rounded-[8px] md:gap-2 w-full border border-[2px] border-[#F2F2F2B8] overflow-y-auto bg-white mb-3">
            {days?.map((item, index) => {
              return (
                <div
                  key={index}
                  className={`flex flex-col flex-1 rounded-[11px] !py-[28px] md:!px-[10px] cursor-pointer border border-white gap-[10px] bg-white text-black
                                      ${
                                        item === selectedDay
                                          ? "bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white "
                                          : "hover:border hover:border-[#0575E6] hover:text-[#0575E6]"
                                      }
                                      `}
                  onClick={() => setSelectedDay(item)}
                >
                  <p className="text-[14px] font-[Lato] font-[400] text-center">
                    {t(
                      `dietPlanDashboard.allMeals.daysShort.${item?.slice(
                        0,
                        3
                      )}`
                    )}
                  </p>

                  {/* <p className="text-[14px] font-[Lato] text-center">
                    {format(item, "dd")}
                  </p> */}
                </div>
              );
            })}
          </div>

          <MotivationCardsView heading={`✨ Your ${selectedDay} Motivation ✨`} />
        </div>
      ) : (
          <MotivationCardsView heading="✨ Your Daily Motivation ✨"  />
      )}
    </div>
  );
};

export default DashboardSuggestion;
